var mp = mp || {};

// Data Tables
//-----------------------------------------------------------------
mp.dataTabels = function() {

    var $containter = $('#dataTables');
    if (!$containter.length) {
        return;
    }

    $.extend( $.fn.dataTable.defaults, {
    	responsive: true,
    	lengthChange: false,
        pageLength: 20,
        ordering: false,
    });

    $containter.DataTable();
};



// Set Datepicker
//-----------------------------------------------------------------
mp.datePicker = function() {
    var $element = $('.js_datePicker');
    if (!$element.length) {
        return;
    }

    $element.datepicker({
        'format': 'dd.mm.yyyy.',
        'autoclose': true,
        'language': 'hr',
        'orientation': 'bottom',
        'weekStart': '1',
        'daysOfWeekHighlighted': '0,6',
        'datesDisabled': $datesDisabled,
    });
};


// Datepicker Avaliability
//-----------------------------------------------------------------
mp.datePickerAvailability = function() {
    var $element = $('.js_datePickerAvailability');
    if (!$element.length) {
        return;
    }

    $element.datepicker({
        'startDate': 'today',
        'format': 'dd.mm.yyyy.',
        'language': 'hr',
        'orientation': 'bottom',
        'weekStart': '1',
        'daysOfWeekHighlighted': '0,6',
        'datesDisabled': $datesDisabled,
    });
};



// Confirmation Popup
//-----------------------------------------------------------------
mp.confirmationPopup = function() {
    var $element = $('.confirm-pop');
    if (!$element.length) {
        return;
    }

    $element.on("click",function(e){
        var pop = confirm("Dali ste sigurni?");
        if (pop != true) {
            e.preventDefault();
            return false;
        }
    });
};


$(document).ready(function (){
    mp.dataTabels();
    mp.datePicker();
    mp.datePickerAvailability();
    mp.confirmationPopup();
});